/** 默认 ◎：双圆环，中心透出底色；内圆直径为画布 45%，与悬浮 FAB 比例一致 */

export function DefaultGlyphIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="12" cy="12" r="5.4" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export function DefaultRingIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
